import { TriggerFilters } from "@services/triggers/types";
import {
  SLFilterToSearch,
  asNonEmptyArray,
  asBoolean,
  asString,
} from "./common";
import { priorityMap } from "./tickets";
const stringToBoolean = (value: string): boolean | undefined =>
  value ? value === "true" : value === "false" ? false : undefined;

export const widgetFilterToSLFilter = (
  filters: (WidgetFilter | FilterDefinition)[] = []
): TriggerFilters => {
  let mapped: TriggerFilters = {};
  filters.forEach((f) => {
    switch (f.filterType as FilterTypes) {
      case "applicableOnly":
        mapped.hideNotApplicable = stringToBoolean(f.filterValue);
        break;
      case "active":
        mapped["threshold.active"] = stringToBoolean(f.filterValue);
        break;
      case "workflow":
        mapped["threshold.workflow"] = stringToBoolean(f.filterValue);
        break;
      case "priority":
        const priorityFilter: TriggerFilters["threshold.priority"] = [];
        (Array.isArray(f.payload)
          ? f.payload
          : f.filterValue
          ? [f.filterValue]
          : []
        ).forEach((value) => {
          const priorityValue = priorityMap[value as TriggersPriorityFilter];
          priorityFilter.push(priorityValue as any);
        });
        if (priorityFilter.length > 0)
          mapped["threshold.priority"] = priorityFilter;
        break;
      case "target":
        const { manufacturer, deviceType, category, model } =
          f.payload as TargetFilterPayload;
        mapped = {
          ...mapped,
          ["threshold.manufacturer"]: manufacturer,
          ["threshold.deviceModel"]: model,
          ["threshold.deviceType"]: deviceType as string, // ! to be remove
          ["threshold.category"]: category,
        };
        break;
      case "accountId":
        if (f.filterValue) mapped.accountId = f.filterValue;
        break;
      default:
        break;
    }
  });
  return mapped;
};

const SLFilterToWidgetFilter = (
  slFilters: TriggerFilters
): FilterDefinition[] => {
  const filters: FilterDefinition[] = [];

  if (slFilters.accountId !== undefined)
    filters.push({
      filterType: "accountId",
      filterValue: slFilters.accountId,
    });
  if (slFilters["threshold.priority"] !== undefined) {
    filters.push({
      filterType: "status",
      filterValue: "",
      payload: slFilters["threshold.priority"].map((v) => v.toLowerCase()),
    });
  }
  let targetPayload: TargetFilterPayload = {
    manufacturer: slFilters["threshold.manufacturer"],
    deviceType: slFilters["threshold.deviceType"],
    category: slFilters["threshold.category"],
    model: slFilters["threshold.deviceModel"],
  };
  const targetPayloadValues = Object.entries(targetPayload).filter((x) => x[1]);
  if (targetPayloadValues.length > 0)
    filters.push({
      filterType: "target",
      filterValue: "",
      payload: targetPayload,
    });
  if (slFilters["threshold.active"] !== undefined)
    filters.push({
      filterType: "active",
      filterValue: slFilters["threshold.active"] ? "true" : "false",
    });
  if (slFilters["threshold.workflow"] !== undefined)
    filters.push({
      filterType: "workflow",
      filterValue: slFilters["threshold.workflow"] ? "true" : "false",
    });
  if (slFilters.hideNotApplicable !== undefined)
    filters.push({
      filterType: "applicableOnly",
      filterValue: slFilters.hideNotApplicable ? "true" : "false",
    });

  return filters;
};

export const searchToSLFilter = (params: URLSearchParams): TriggerFilters => {
  const filters: TriggerFilters = {};
  asString(filters, params, [
    "accountId",
    "threshold.manufacturer",
    "threshold.deviceModel",
    "threshold.deviceType",
    "threshold.category",
  ]);
  asBoolean(filters, params, [
    "threshold.active",
    "hideNotApplicable",
    "threshold.workflow",
  ]);
  asNonEmptyArray(filters, params, ["threshold.priority"]);
  return filters;
};

export default {
  fromDefinition: {
    toSL: (filters?: (WidgetFilter | FilterDefinition)[]) =>
      widgetFilterToSLFilter(filters),
    toSearchParams: (filters?: (WidgetFilter | FilterDefinition)[]) =>
      SLFilterToSearch(widgetFilterToSLFilter(filters)),
  },
  fromSL: {
    toDefinition: (f: TriggerFilters) => SLFilterToWidgetFilter(f),
    toSearchParams: (f: TriggerFilters) => SLFilterToSearch(f),
  },
  fromSearchParams: {
    toSL: searchToSLFilter,
    toDefinition: (params: URLSearchParams) =>
      SLFilterToWidgetFilter(searchToSLFilter(params)),
  },
};
